import PATHS from '../constants';

function fetchProject() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.PROJECT, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchProject;